import { render, staticRenderFns } from "./PreApprovedEmailDomainEditForm.vue?vue&type=template&id=b2312dbe"
import script from "./PreApprovedEmailDomainEditForm.vue?vue&type=script&lang=js"
export * from "./PreApprovedEmailDomainEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports